export class Plant {

    public id: number;
    public name: string;
    public description: string;
    public lines: any[];
    public inUse: boolean;
    public documentsLocation: string;

    constructor(plant: any = {}) {
        this.id = plant.id || 0;
        this.name = plant.name || '';
        this.description = plant.description || '';
        this.lines = plant.lines ? plant.lines : [];
        this.inUse = plant.inUse;
        this.documentsLocation = plant.documentsLocation || '';
    }

    get type() {
        return 'plant';
    }

}
